(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ost-tabs-fragrance"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ost-tabs-section').forEach(section => {
  const buttons = section.querySelectorAll('.ost-tabs-buttons button');
  const tabs = section.querySelectorAll('.ost-tabs-tab');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.tab;

      // 1. Cacher tous les tabs de cette section
      tabs.forEach(tab => {
        tab.style.display = 'none';
      });

      // 2. Afficher seulement le tab ciblé
      const targetTab = section.querySelector('#' + targetId);
      if (targetTab) {
        targetTab.style.display = '';
      }

      // (Optionnel) gérer l'état "actif" sur les boutons
      buttons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  // (Optionnel) initialisation : afficher seulement le premier tab
  // et marquer le premier bouton comme actif
  if (buttons.length > 0 && tabs.length > 0) {
    buttons[0].classList.add('is-active');
    tabs.forEach((tab, index) => {
      tab.style.display = index === 0 ? '' : 'none';
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
